export function cloneToStatic(video, mirror) {
  const videoCanvas = document.createElement('canvas');
  videoCanvas.style.display = 'block';
  videoCanvas.width = video.videoWidth;
  videoCanvas.height = video.videoHeight;

  const context = videoCanvas.getContext('2d');

  if (mirror) {
    context.translate(videoCanvas.width, 0);
    context.scale(-1, 1);
  }

  context.drawImage(video, 0, 0);

  const canvasContainer = document.createElement('div');

  const { width, height } = video.getBoundingClientRect();

  canvasContainer.style.width = `${width}px`;
  canvasContainer.style.height = `${height}px`;
  canvasContainer.style.marginLeft = video.style.marginLeft;
  canvasContainer.style.position = 'relative';

  video.disabled = 'disabled';
  video.style.display = 'hidden';
  video.parentNode.insertBefore(canvasContainer, video);

  canvasContainer.appendChild(videoCanvas);
  videoCanvas.style.width = '100%';
  videoCanvas.style.height = '100%';
  videoCanvas.style.objectFit = 'contain';

  return canvasContainer;
}

export function dataURItoBlob(dataURI) {
  const mimeString = dataURI
    .split(',')[0]
    .split(':')[1]
    .split(';')[0];
  const byteString = atob(dataURI.split(',')[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ab], { type: mimeString });
}

export function dasherize(str) {
  return (
    str[0] +
    str
      .slice(1)
      .replace(/([A-Z])/g, '-$1')
      .replace(/[-_\s]+/g, '-')
  ).toLowerCase();
}

export function hideTag(tag) {
  if (tag) {
    if (tag.object3d) {
      tag.object3d.visible = false;
    } else {
      tag.element.style.display = 'none';
    }
  }
}

export function showTag(tag) {
  if (tag) {
    if (tag.object3d) {
      tag.object3d.visible = true;
    } else {
      tag.element.style.display = 'block';
    }
  }
}

export function tagOnClick(tag, handler) {
  if (tag) tag.element.addEventListener('click', handler);
}

export function tagOnHold(tag, handler) {
  if (tag) {
    tag.element.addEventListener('mousedown', function() {
      const tapFinish = new Promise(resolve => {
        document.body.addEventListener('mouseup', resolve, { once: true });
      });
      handler(tapFinish);
    });

    tag.element.addEventListener('touchstart', function(e) {
      e.preventDefault();
      const tapFinish = new Promise(resolve => {
        document.body.addEventListener('touchend', resolve, { once: true });
      });
      handler(tapFinish);
    });
  }
}

export function encodeParams(params) {
  return Object.entries(params)
    .map(param => {
      return param.map(s => encodeURIComponent(s)).join('=');
    })
    .join('&');
}

export function encodeURL(url, params) {
  return [url, encodeParams(params)].filter(s => s && s.length).join('?');
}

export function sleep(ms = 1000) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function wrapLink(element, options = {}) {
  const link = document.createElement('a');

  if (options.className) {
    link.classList.add(options.className);
  }

  if (options.url) {
    link.href = options.url;
  }

  if (options.target) {
    link.target = options.target;
  }

  Array.prototype.slice.apply(element.childNodes).forEach(el => link.appendChild(el));
  element.appendChild(link);

  return link;
}

export function setupTapToChange(ctaTags, tags, groupName, callback) {
  let currentTapPosition = 1;
  let tapPositionCount = 0;
  let regex = new RegExp(`${groupName}-(\\d+)`);

  tags.forEach(tag => {
    const positionMatch = tag.classNames.match(regex);
    if (positionMatch) {
      const position = parseInt(positionMatch[1], 10);

      tag.tapToChangePosition = position;
      tapPositionCount = Math.max(tapPositionCount, position);

      if (position > 1) {
        hideTag(tag);
      }
    }
  });

  function nextPosition(e) {
    e.preventDefault();

    currentTapPosition += 1;
    if (currentTapPosition > tapPositionCount) {
      currentTapPosition = 1;
    }

    callback(currentTapPosition);
  }

  ctaTags.forEach(tag => {
    tag.element.addEventListener('click', nextPosition);
    tag.element.addEventListener('touchstart', nextPosition);
  });
}

export function displayVideo(tag, url) {
  const video = document.createElement('video');
  video.src = url;
  video.autoplay = true;
  video.muted = true;
  video.loop = true;
  video.style.height = '100%';
  tag.element.prepend(video);

  return video;
}

export function displayImage(tag, url) {
  const image = new Image();
  image.src = url;
  tag.element.prepend(image);

  return image;
}

export default '';
